import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';

import { TPracticeType } from '../../types.ts';

import { useColumnsVisibility } from '@/contexts/column-visibility';
import { usePagination, useSorting } from '@/hooks';
import { normalizeData } from '@/modules/practices/utils/normalize-data.ts';
import { API } from '@/services/api';
import { PaginatedTable } from '@/widgets/paginated-table';

export const PracticesTable: FC = () => {
    const { visibleColumns } = useColumnsVisibility<TPracticeType>();
    const [searchParams] = useSearchParams();
    const { pagination } = usePagination();
    const { sort } = useSorting();
    const searchValue = searchParams.get('search');

    const { data, isLoading, isPending } = useQuery({
        ...API.PRACTICES.getPractices({
            search: searchValue,
            ...sort,
            ...pagination,
        }),
    });

    return (
        <PaginatedTable<TPracticeType>
            columns={visibleColumns}
            dataSource={normalizeData(data?.result || [])}
            loading={isPending || isLoading}
            total={data?.total || 0}
        />
    );
};
